
export class ResetPasswordModel {
  userId: string;
}
